"use strict";

function StepperControl (
    strUlSelector_I
)
{
    if (typeof window !== 'undefined') {
        var $ = window.$;
        this.Stepper = $(strUlSelector_I);
        this.arrStepperChilds = this.Stepper.children();
    }
}

StepperControl.prototype.intCountChilds = function()
{
    // console.log("li child counter: "+this.arrStepperChilds.length);
    return this.arrStepperChilds.length;
}

StepperControl.prototype.subNextStep = function(
    intNextStep_I
)
{
    if  (
        this.intCountChilds() > 0 && intNextStep_I <= this.intCountChilds()
        )
    {
        $(this.arrStepperChilds[intNextStep_I - 1]).addClass('stepper-active');
    }
}

StepperControl.prototype.subRemoveStep = function(
    intCurrentStep_I
)
{
    if  (
        intCurrentStep_I > 0 && intCurrentStep_I <= this.intCountChilds()
        )
    {
        //Delete class 'stepper-active' for the current step
        $(this.arrStepperChilds[intCurrentStep_I - 1]).removeClass('stepper-active');
    }
}

StepperControl.prototype.subBackToStep = function(
    intCurrentStep_I
)
{
    if  (
        intCurrentStep_I > 0 && intCurrentStep_I <= this.intCountChilds()
        )
    {
        //Delete class 'stepper-active' from all steps after the desired step
        for (let index = 0; index < this.arrStepperChilds.length; index++) {
            if (
                (index + 1) > intCurrentStep_I
                )
            {
                $(this.arrStepperChilds[index]).removeClass('stepper-active');
            }
        }
    }
}

module.exports = StepperControl;